<script>
import Layout from '@layouts/main'
import { cdmMethods } from '@state/helpers'
import _ from 'lodash'
import FilterPanel from '@components/filter-panel'

export default {
  metaInfo: {
    title: 'Cdms',
    meta: [{ name: 'description', content: 'Cdms' }],
  },
  components: {
    Layout,
    FilterPanel,
  },
  props: {
    fields: {
      type: Array,
      required: true,
    },
    approvalWorkflows: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      dialog: false,
      search: '',
      loadingError: null,
      loading: true,
      isWorking: false,
      createError: null,
      pagination: {
        rowsPerPage: 8,
      },
      items: [],
      changeItems: ['Make Inactive', 'Update Price'],
      totalData: 0,

      // TODO: Replace with real data
      dummyHeaders: [
        { text: 'Department', value: 'department' },
        { text: 'Maps', value: 'maps' },
        { text: 'Description', value: 'description' },
        { text: 'CPT Medicare', value: 'cpt' },
        { text: 'MOD Medicare', value: 'mod' },
        { text: 'Price', value: 'price' },
      ],
      dummyItems: [
        {
          department: '220',
          description: 'X-RAY EXAM CHEST 1 VIEW',
          cpt: '77012',
          mod: 'RT',
          price: '$1,051.00',
        },
        {
          department: '120',
          description: 'CT SCAN FOR NEEDLE BIOPSY',
          cpt: '77031',
          mod: 'LT',
          price: '$1,093.00',
        },
        {
          department: '252',
          description: 'STEREOTATIC LOCALIZATION/S&L/',
          cpt: '77034',
          mod: 'BT',
          price: '$679.00',
        },
        {
          department: '189',
          description: 'NEEDLE LOCA/SAME BRST/EA ADDT',
          cpt: '77039',
          mod: 'AT',
          price: '$1,986.22',
        },
        {
          department: '220',
          description: 'X-RAY EXAM CHEST 1 VIEW',
          cpt: '77012',
          mod: 'RT',
          price: '$1,051.00',
        },
        {
          department: '120',
          description: 'CT SCAN FOR NEEDLE BIOPSY',
          cpt: '77031',
          mod: 'LT',
          price: '$1,093.00',
        },
        {
          department: '252',
          description: 'STEREOTATIC LOCALIZATION/S&L/',
          cpt: '77034',
          mod: 'BT',
          price: '$679.00',
        },
        {
          department: '189',
          description: 'NEEDLE LOCA/SAME BRST/EA ADDT',
          cpt: '77039',
          mod: 'AT',
          price: '$1,986.22',
        },
      ],
      newItem: {
        faculty: null,
        revenueDept: null,
        comment: null,
        mmisNumber: null,
        mfgCatalog: null,
        manufacturer: null,
        description: null,
        commodityCode: null,
        packaging: null,
      },
    }
  },
  computed: {
    sortedActiveFields() {
      var fields = this.fields.filter(
        x => x.showInTable === true || x.uniqueIdentifier === true
      )
      return fields.sort(function(a, b) {
        return a.order - b.order
      })
    },
    headers() {
      return this.sortedActiveFields.map(field => {
        return { text: field.caption || field.name, value: field.name }
      })
    },
  },
  watch: {
    pagination: {
      handler() {
        this.getDataFromApi()
      },
      deep: true,
    },
    search: {
      handler() {
        this.getDataFromApi()
      },
    },
    dialog(val) {
      val || this.close()
    },
  },
  created() {
    this.getDataFromApi = _.debounce(this.getDataFromApi, 500)
  },
  methods: {
    ...cdmMethods,
    cptUrlForCode(code) {
      return `https://coder.aapc.com/search/?keyword=${code}`
    },

    // Route to CDM view
    goToCdm(cdm) {
      this.$router.push({ name: 'viewCdm', params: { cdmId: cdm.CMNIdField } })
    },
    getDataFromApi() {
      this.loading = true
      var vm = this
      return this.getOnlyCdms({
        force: true,
        queryTerms: { ...this.pagination, filter: this.search },
      })
        .then(data => {
          vm.loading = false

          vm.totalData = data.totalCount
          vm.items = data.results
        })
        .catch(error => {
          vm.loading = false
          vm.loadingError = error
        })
    },
    close() {
      this.dialog = false
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    },
  },
}
</script>

<template>
  <Layout>
    <!-- DUMMY TABLE (CDMS) -->
    <v-container fluid grid-list-md ma-0>
      <!-- Header -->
      <v-layout row>
        <h3>C3</h3>
      </v-layout>

      <v-layout row>
        <div :class="$style.tables">
          <v-card>
            <v-card-title>
              <v-layout>
                <v-flex md8>
                  <v-layout align-center>
                    <v-flex md2 class="pl-3">
                      # selected
                    </v-flex>

                    <v-flex align-self-start md4>
                      <v-select
                        class="ml-3 mr-5"
                        :class="$style.actions"
                        :items="changeItems"
                        label="Change"
                        color="cyan"
                      ></v-select>
                    </v-flex>
                  </v-layout>
                </v-flex>

                <v-flex md3 text-right>
                  <v-text-field
                    v-model="search"
                    append-icon="search"
                    label="Search"
                    single-line
                    hide-details
                    color="cyan"
                  ></v-text-field>
                </v-flex>

                <v-flex md2 text-right>
                  <!-- Add dialog -->
                  <v-dialog v-model="dialog" max-width="500px">
                    <v-btn
                      slot="activator"
                      dark
                      depressed
                      color="cyan"
                      class="pl-2 pr-3"
                    >
                      <v-icon dark class="mr-1">add</v-icon> Add New
                    </v-btn>

                    <v-card>
                      <v-card-title class="pb-1">
                        <span class="headline">Add New</span>
                      </v-card-title>

                      <v-card-text class="pt-0 px-4">
                        <v-text-field
                          v-model="newItem.faculty"
                          type="text"
                          color="cyan"
                          label="Faculty"
                        ></v-text-field>
                        <v-text-field
                          v-model="newItem.revenueDept"
                          type="text"
                          color="cyan"
                          label="RevenueDept"
                        ></v-text-field>
                        <v-text-field
                          v-model="newItem.comment"
                          type="text"
                          color="cyan"
                          label="Comment"
                        ></v-text-field>
                        <v-text-field
                          v-model="newItem.mmisNumber"
                          type="text"
                          color="cyan"
                          label="MMISNumber"
                        ></v-text-field>
                        <v-text-field
                          v-model="newItem.mfgCatalog"
                          type="text"
                          color="cyan"
                          label="Mfg Catalog #"
                        ></v-text-field>
                        <v-text-field
                          v-model="newItem.manufacturer"
                          type="text"
                          color="cyan"
                          label="Manufacturer"
                        ></v-text-field>
                        <v-text-field
                          v-model="newItem.description"
                          type="text"
                          color="cyan"
                          label="Description"
                        ></v-text-field>
                        <v-text-field
                          v-model="newItem.commodityCode"
                          type="text"
                          color="cyan"
                          label="CommodityCode"
                        ></v-text-field>
                        <v-text-field
                          v-model="newItem.packaging"
                          type="text"
                          color="cyan"
                          label="Packaging"
                        ></v-text-field>

                        <BaseLink name="">
                          <img
                            src="/assets/icon-add.svg"
                            alt="+"
                            class="mr-1"
                          />
                          Add and Create Another
                        </BaseLink>

                        <v-layout justify-content-end>
                          <v-btn
                            color="cyan"
                            dark
                            depressed
                            outline
                            @click="close"
                            >Cancel</v-btn
                          >
                          <v-btn color="cyan" dark depressed>Save</v-btn>
                        </v-layout>
                      </v-card-text>
                    </v-card>
                  </v-dialog>
                </v-flex>
              </v-layout>
            </v-card-title>

            <!-- Data table -->
            <v-data-table
              :headers="headers"
              :items="items"
              :pagination.sync="pagination"
              :total-items="totalData"
              :loading="loading"
              select-all
            >
              <v-progress-linear
                slot="progress"
                color="blue"
                indeterminate
              ></v-progress-linear>
              <template slot="items" slot-scope="props">
                <td>
                  <v-checkbox
                    v-model="selectedTasks"
                    :value="item"
                    color="cyan"
                    hide-details
                  />
                </td>
                <td
                  v-for="field in sortedActiveFields"
                  :key="field.id"
                  @click="
                    if (!field.procedureCode) {
                      goToCdm(props.item)
                    }
                  "
                >
                  <div v-if="field.procedureCode">
                    <a
                      target="_blank"
                      :href="cptUrlForCode(props.item[field.name])"
                      >{{ props.item[field.name] }}</a
                    >
                  </div>
                  <!-- Active dot -->
                  <div v-else-if="field.name === 'Active'">
                    <v-icon
                      v-if="props.item[field.name] === 'Y'"
                      size="x-small"
                      color="black"
                      >mdi-circle</v-icon
                    >
                    <v-icon v-else size="x-small" color="#c3c3c3"
                      >mdi-circle</v-icon
                    >
                  </div>
                  <div v-else>{{ props.item[field.name] }}</div>
                </td>
              </template>
            </v-data-table>
          </v-card>

          <!-- TABBED TABLE -->
          <v-card class="mt-3">
            <v-tabs color="transparent" slider-color="cyan" class="mx-3 pb-2">
              <v-tab>Chargemaster</v-tab>
              <v-tab>Order Entry</v-tab>

              <v-tab-item :class="$style.tabItem">
                <v-data-table
                  :headers="dummyHeaders"
                  :items="dummyItems"
                  :loading="loading"
                  hide-actions
                >
                  <template slot="items" slot-scope="props">
                    <td>{{ props.item.department }}</td>
                    <td><v-checkbox color="cyan" hide-details /></td>
                    <td>{{ props.item.description }}</td>
                    <td>{{ props.item.cpt }}</td>
                    <td>{{ props.item.mod }}</td>
                    <td>{{ props.item.price }}</td>
                  </template>
                </v-data-table>
              </v-tab-item>

              <v-tab-item :class="$style.tabItem">
                B
              </v-tab-item>
            </v-tabs>
          </v-card>
        </div>

        <FilterPanel />
      </v-layout>
    </v-container>
  </Layout>
</template>

<style lang="scss" module>
@import '@design';

.tabItem {
  border-top: 1px solid gainsboro;
}

.tables {
  width: calc(100% - 300px);
}
</style>
